module.exports = __webpack_public_path__ + "static/media/21.317b3c8d.JPG";